import { API_ENDPOINT } from "./config";
import { getAuthToken } from "../utils/auth";
import { generateEncryptedToken } from "../utils/crypto";

export async function apiPost(url, body, isFormData = false) {
    const token = getAuthToken();
    const encryptedToken = generateEncryptedToken();
    const headers = {};
    if (!isFormData) {
        headers["Content-Type"] = "application/json";
    }
    if (encryptedToken) {
        headers["Oauth"] = `${encryptedToken}`;
    }
    if(token) {
        headers["Authorization"] = `${token}`;
    }

    const response = await fetch(`${API_ENDPOINT}${url}`, {
        method: "POST",
        headers,
        body: isFormData ? body : JSON.stringify(body),
    });

    // Try reading error body safely
    const text = await response.text();
    let data;
    try {
        data = text ? JSON.parse(text) : {};
    } catch {
        data = { message: text };
    }

    if (!response.ok) {
        // Preserve error details
        const error = new Error(data.message || "API request failed");
        error.status = response.status;
        error.details = data;
        throw error;
    }

    return data;
}
